module.exports = __webpack_public_path__ + "static/media/slider2.f7c38012.jpg";